import http from "../http";

const UserService = {
    getUsers: async () => {
        const users = await http.instance.get("/users");
        return users.data
    },

};
export default UserService;
